// extracted by mini-css-extract-plugin
export default {"container":"NoResultPrompt_container__Cd2IB"};